import { render, staticRenderFns } from "./SellFormCasavo.vue?vue&type=template&id=42615308"
import script from "./SellFormCasavo.vue?vue&type=script&lang=js"
export * from "./SellFormCasavo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports